export default {}

export const pageTitle = 'Gaurav Publications'
export const subTitle = ''
export const apiUrl = `https://api.gauravpublications.com`
// export const apiUrl = `http://localhost:8098`

